"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteFullTable = void 0;
var react_1 = __importStar(require("react"));
require("./index.less");
var qtpager_1 = require("../qtpager");
var config_1 = require("../../modules/quote/config");
var quote_1 = require("../../modules/quote");
var addzxgbtn_1 = require("../page/shared/zxg/addzxgbtn");
var tablepage_config_1 = require("./tablepage_config");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
/**
 * 行情表格全屏表格
 * @returns
 */
function QuoteFullTable(props) {
    var _a;
    var _b = (0, react_1.useState)([]), showdata = _b[0], SetShowData = _b[1];
    var location = (0, react_router_dom_1.useLocation)();
    var hash = location.hash.toLowerCase();
    if (hash.substring(0, 1) == '#') {
        hash = hash.substring(1);
    }
    var thishash = (0, react_1.useRef)(hash);
    var reffloatHead = (0, react_1.useRef)(null);
    var reforiginHead = (0, react_1.useRef)(null);
    //配置字段
    var hashtable_item = tablepage_config_1.hashtable[hash];
    var tableitem = (0, lodash_1.cloneDeep)(tablepage_config_1.tableitemconfig[hashtable_item.table]);
    //自定义字段
    if (props.custom_item) {
        var customindex = tableitem.findIndex(function (v) { return v.type == 'custom'; });
        if (customindex > -1) {
            tableitem = tableitem.slice(0, customindex).concat([__assign({ type: 'quote' }, props.custom_item)]).concat(tableitem.slice(customindex + 1));
        }
    }
    var mt = (_a = props.mt) !== null && _a !== void 0 ? _a : 0;
    var default_sort = getDefaultSort(tableitem); //默认排序  
    var _c = (0, react_1.useState)(0), count = _c[0], SetCount = _c[1];
    var _d = (0, react_1.useState)(1), nowindex = _d[0], SetNowIndex = _d[1];
    var _e = (0, react_1.useState)(default_sort.sort), sortitem = _e[0], SetSortItem = _e[1];
    var _f = (0, react_1.useState)(default_sort.sort_direct), sortdirect = _f[0], SetSortDirect = _f[1];
    var _g = (0, react_1.useState)(Math.random()), data_reload = _g[0], setReload = _g[1];
    var pagesize = 50;
    var getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fs, quotedata;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fs = hashtable_item.fs;
                        return [4 /*yield*/, (0, quote_1.searchListQuoteWithPage)(fs, tableitem.filter(function (v) { return v.type == 'quote'; }).map(function (v) { return config_1.QuoteItem[v.value]; }), sortitem, nowindex, pagesize, sortdirect)];
                    case 1:
                        quotedata = _a.sent();
                        if (quotedata.result.length > 0)
                            SetShowData(quotedata.result);
                        SetCount(quotedata.count);
                        return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (hash != thishash.current) {
            SetNowIndex(1);
            SetSortItem(default_sort.sort);
            SetSortDirect(default_sort.sort_direct);
            setReload(Math.random());
        }
        thishash.current = hash;
    }, [hash]);
    (0, react_1.useEffect)(function () {
        getData();
        setTimeout(function () {
            initFloatHead($(reforiginHead.current), $(reffloatHead.current));
        }, 100);
    }, [nowindex, sortdirect, sortitem, props.custom_item, data_reload]);
    var changeSort = function (tosortitem) {
        var _a;
        SetSortItem(tosortitem);
        if (sortitem == tosortitem) {
            if (sortdirect == 0) {
                SetSortDirect(1);
            }
            else {
                SetSortDirect(0);
            }
        }
        else {
            // SetSortDirect(1)
            SetSortDirect((_a = props.first_sort) !== null && _a !== void 0 ? _a : 1);
        }
    };
    var refresh = function () {
        getData();
    };
    return (react_1.default.createElement("div", { className: "quotetable table_fullscreen", style: mt > 0 ? { marginTop: mt } : {} },
        react_1.default.createElement("table", null,
            react_1.default.createElement(TableHead, { tableitem: tableitem, ListItemConfig: config_1.ListItemConfig, changeSort: changeSort, sortitem: sortitem, sortdirect: sortdirect, reforiginHead: reforiginHead }),
            react_1.default.createElement(TableHead, { isFloat: true, tableitem: tableitem, ListItemConfig: config_1.ListItemConfig, changeSort: changeSort, sortitem: sortitem, sortdirect: sortdirect, reffloatHead: reffloatHead }),
            react_1.default.createElement("tbody", null, showdata.map(function (v, index) {
                return react_1.default.createElement("tr", { key: index }, tableitem.filter(function (v) { return v.hide != true; }).map(function (v2, index2) {
                    return react_1.default.createElement("td", { key: index2, className: v2.tdclass ? v2.tdclass : '' },
                        v2.type == 'index' && ((nowindex - 1) * pagesize + index + 1),
                        v2.type == 'quote' && v[config_1.QuoteItem[v2.value]] && v[config_1.QuoteItem[v2.value]].html,
                        v2.type == 'gb_kzz_link' && v[config_1.QuoteItem.代码带链接] && v[config_1.QuoteItem.市场] &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("a", { href: "//guba.eastmoney.com/list,".concat(v[config_1.QuoteItem.市场].txt == '1' ? "sh" : "sz").concat(v[config_1.QuoteItem.代码带链接].txt, ".html") }, "\u80A1\u5427"),
                                "\u00A0",
                                react_1.default.createElement("a", { href: "//data.eastmoney.com/kzz/detail/".concat(v[config_1.QuoteItem.代码带链接].txt, ".html") }, "\u8BE6\u7EC6")),
                        v2.type == 'add_zxg' &&
                            react_1.default.createElement(addzxgbtn_1.AddZXGBtn, { quotecode: v[config_1.QuoteItem.行情统一链接].source }));
                }));
            }))),
        count > 0 &&
            react_1.default.createElement(qtpager_1.QTPager, { count: count, pagesize: pagesize, nowindex: nowindex, onChangePager: function (toindex) { SetNowIndex(toindex); } })));
}
exports.QuoteFullTable = QuoteFullTable;
/**
 * 表头
 * @param props
 * @returns
 */
function TableHead(props) {
    var tableitem = props.tableitem || [];
    var ListItemConfig = props.ListItemConfig;
    var sortitem = props.sortitem;
    var sortdirect = props.sortdirect;
    var changeSort = function (sort) {
        props.changeSort && props.changeSort(sort);
    };
    return (react_1.default.createElement("thead", { ref: props.isFloat ? props.reffloatHead : props.reforiginHead, className: props.isFloat ? 'float_head' : '' },
        react_1.default.createElement("tr", null, tableitem.filter(function (v) { return v.hide != true; }).map(function (v, index) {
            return react_1.default.createElement("th", { key: index, className: v.sort ? 'sort' : '', title: v.sort ? '点击排序' : '', onClick: function () { if (v.sort) {
                    changeSort(ListItemConfig === null || ListItemConfig === void 0 ? void 0 : ListItemConfig[config_1.QuoteItem[v.value]].sort);
                } } },
                v.title,
                v.tip && react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: v.tip } }),
                v.sort && (ListItemConfig === null || ListItemConfig === void 0 ? void 0 : ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 1 &&
                    react_1.default.createElement("span", { className: "icon_down" }),
                v.sort && (ListItemConfig === null || ListItemConfig === void 0 ? void 0 : ListItemConfig[config_1.QuoteItem[v.value]].sort) == sortitem && sortdirect == 0 &&
                    react_1.default.createElement("span", { className: "icon_up" }));
        }))));
}
/**
 * 获取默认的排序设置
 * @param config
 * @returns
 */
function getDefaultSort(config) {
    var finddefault = config.find(function (v) { return v.sort_default; });
    if (finddefault) {
        return {
            sort: config_1.ListItemConfig[config_1.QuoteItem[finddefault.value]].sort,
            sort_direct: finddefault.sort_direct
        };
    }
    return {
        sort: '',
        sort_direct: 1
    };
}
/**
 * 浮动表头事件
 */
function initFloatHead(originhead, floathead) {
    $('tr', originhead).find('th').each(function (index, el) {
        $('tr', floathead).find('th').eq(index).width($(el).width() || 0);
    });
    $(window).on('scroll', function () {
        var table = $('.quotetable');
        var table_h = table.height() || 0, scroll_h = $(window).scrollTop() || 0, offsettop = table.offset().top || 0;
        if (scroll_h > offsettop) {
            floathead.show();
            // if (scroll_h > (offsettop + table_h) - 50) floathead.hide();
        }
        else {
            floathead.hide();
        }
    });
}
;
